import React, { useEffect, useState } from "react";
import { Modal, Input, Form, Row, Col, Typography, Select } from "antd";

const { Item } = Form;
const { Title } = Typography;
const { Option } = Select;

const AddMachineModal = (props) => {
  const {
    form,
    open,
    close,
    editable: parentEditable = true,
    data = null,
    onSave,
    userOptions = [],
    branchOptions = [],
  } = props;
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = form;
  const [editable, setEditable] = useState(Boolean(parentEditable));

  useEffect(() => {
    setEditable(Boolean(parentEditable));
  }, [parentEditable]);

  useEffect(() => {
    if (data) {
      setFieldsValue({
        machineId: data.machineId || "",
        branch: data.branch.id || "",
        clientId: data.clientId || "",
        merchantId: data.merchantId || "",
        storeId: data.storeId || "",
        securityToken: data.securityToken || "",
        MBR : data.MBR || "",
        userIds: Array.isArray(data.userIds)
        ? data.userIds.map((u) => (typeof u === "object" ? u.id : u))
        : [],
      });
    } else {
      resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSubmit = () => {
    if (!editable) {
      setEditable(true);
      return;
    }

    validateFields(async (err, values) => {
      if (err) return;
      const payload = { ...values };
      if (data && data.id) payload.id = data.id;

      try {
        await onSave(payload);
        resetFields();
        close();
      } catch (e) {
        console.error("Save failed", e);
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data ? "Machine" : "Add Machine"}</Title>}
      visible={open}
      okText={editable ? (data ? "Save" : "Add") : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      onOk={handleSubmit}
      destroyOnClose
    >
      <Form layout="vertical">
        <Row gutter={[16, 8]}>
          <Col span={12}>
            <Item label="Machine ID" required>
              {getFieldDecorator("machineId", {
                rules: [
                  { required: true, message: "Enter Machine ID" },
                  { pattern: /^[a-zA-Z0-9]+$/, message: "Special characters are not allowed" }
                ],
              })(
                <Input
                  placeholder="Machine ID"
                  disabled={!editable}
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  }}
                  onKeyUp={(e) => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    form.setFieldsValue({ machineId: val });
                  }}
                />
              )}
            </Item>
          </Col>

          <Col span={12}>
            <Item label="Branch" required>
              {getFieldDecorator("branch", {
                rules: [{ required: true, message: "Select branch" }],
              })(
                <Select
                  placeholder="Select Branch"
                  disabled={!editable}
                  showSearch
                  optionFilterProp="children"
                >
                  {branchOptions.map((b) => (
                    <Option key={b.id} value={b.id}>
                      {b.name}
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          </Col>
        </Row>

        <Row gutter={[16, 8]}>
          <Col span={12}>
            <Item label="Client ID" required>
              {getFieldDecorator("clientId", {
                rules: [
                  { required: true, message: "Enter Client ID" },
                  { pattern: /^[a-zA-Z0-9]+$/, message: "Special characters are not allowed" }
                ],
              })(
                <Input
                  placeholder="Client ID"
                  disabled={!editable}
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  }}
                  onKeyUp={(e) => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    form.setFieldsValue({ clientId: val });
                  }}
                />
              )}
            </Item>
          </Col>

          <Col span={12}>
            <Item label="Merchant ID" required>
              {getFieldDecorator("merchantId", {
                rules: [
                  { required: true, message: "Enter Merchant ID" },
                  { pattern: /^[a-zA-Z0-9]+$/, message: "Special characters are not allowed" }
                ],
              })(
                <Input
                  placeholder="Merchant ID"
                  disabled={!editable}
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  }}
                  onKeyUp={(e) => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    form.setFieldsValue({ merchantId: val });
                  }}
                />
              )}
            </Item>
          </Col>
        </Row>

        <Row gutter={[16, 8]}>
          <Col span={12}>
            <Item label="Store ID" required>
              {getFieldDecorator("storeId", {
                rules: [
                  { required: true, message: "Enter Store ID" },
                  { pattern: /^[a-zA-Z0-9]+$/, message: "Special characters are not allowed" }
                ],
              })(
                <Input
                  placeholder="Store ID"
                  disabled={!editable}
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  }}
                  onKeyUp={(e) => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    form.setFieldsValue({ storeId: val });
                  }}
                />
              )}
            </Item>
          </Col>

          <Col span={12}>
            <Item label="Security Token" required>
              {getFieldDecorator("securityToken", {
                rules: [
                  { required: true, message: "Enter Security Token" }
                ],
              })(
                <Input
                  placeholder="Security Token"
                  disabled={!editable}
                />
              )}
            </Item>
          </Col>
          <Col span={12}>
            <Item label="MDR (%)" required>
              {getFieldDecorator("MBR", {
                rules: [
                  { required: true, message: "Enter MBR" },
                  { pattern: /^[0-9]+(?:\.[0-9]+)?$/, message: "Enter a valid percentage" }
                ],
              })(
                <Input
                  placeholder="MBR"
                  disabled={!editable}
                  onInput={(event) => {
                    let val = event.target.value.replace(/[^0-9.]/g, "");
                    const parts = val.split(".");
                    if (parts.length > 2) {
                      val = parts[0] + "." + parts.slice(1).join("");
                    }
                    event.target.value = val;
                  }}
                  onKeyUp={(e) => {
                    let val = e.target.value.replace(/[^0-9.]/g, "");
                    const parts = val.split(".");
                    if (parts.length > 2) {
                      val = parts[0] + "." + parts.slice(1).join("");
                    }
                    form.setFieldsValue({ MBR: val });
                  }}
                />
              )}
            </Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Item label="Associate Users">
              {getFieldDecorator("userIds", {
                initialValue: [],
              })(
                <Select
                  mode="multiple"
                  placeholder="Select Associate Users"
                  disabled={!editable}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                >
                  {userOptions.map((u) => (
                    <Option key={u.value} value={u.value}>
                      {u.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedAddMachineModal = Form.create({ name: "add_machine_form" })(
  AddMachineModal
);

export default WrappedAddMachineModal;
